// auth.js
export const isAdminAuthenticated = () => {
    // Replace this with your actual authentication logic
    const user = JSON.parse(localStorage.getItem('user'));
    return user && user.role === 'admin';
  };